// Shared icon sizing for all navigation items.
export const sx = { fontSize: 20 };
